import moment from "moment";
export const initialState = {
  action: "add",
  type: "meeting",
  clientId: null,
  title: "",
  startTime: moment(new Date()).startOf("hour").add(1, "hour"),
  endTime: moment(new Date()).endOf("hour").add(1, "hour"),
  description: "",
  fetching: false,
  inputErrors: null,
  serverMessage: null
};

export const eventTypes = [
  { key: "meeting", label: "Meeting" },
  { key: "call", label: "Call" },
  { key: "email", label: "Email" },
  { key: "other", label: "Other" }
];

const editEventModalReducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "handleInput":
      return {
        ...state,
        [action.field]: action.payload,
        inputErrors: { ...state.inputErrors, [action.field]: null },
        serverMessage: null
      };
    case "setStartTime": {
      return {
        ...state,
        startTime: action.payload
      };
    }
    case "setEndTime": {
      return {
        ...state,
        endTime: action.payload
      };
    }
    case "setEvent": {
      // Here we have to take into account if the payload comes from the backend or frontend as the prop names and stucture can be different
      const payload = action.payload;

      const eventData = {
        action: "update",
        clientId: payload.client_id || payload.clientId,
        title: payload.title || "",
        startTime: payload.start_time || payload.startTime || "",
        endTime: payload.end_time || payload.endTime || "",
        description: payload.description || ""
      };

      return {
        ...state,
        ...eventData
      };
    }
    case "fetching":
      return { ...state, [action.type]: action.payload };
    case "handleSwitchPersonType":
      return { ...initialState, type: action.payload };
    case "handleInputErrors":
      return { ...state, inputErrors: action.payload };
    case "handleServerError":
      return {
        ...state,
        fetching: false,
        serverMessage: { type: "error", text: action.payload }
      };
    case "handleServerSuccess":
      return {
        ...state,
        fetching: false,
        serverMessage: { type: "success", text: action.payload }
      };
    default:
      return state;
  }
};

export default editEventModalReducer;
